// @flow
import * as React from 'react';
import { useState, useEffect } from 'react';
import { FORM_ERROR } from 'final-form';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createFocusOnError from 'final-form-focus';
import classNames from 'classnames/bind';
import { path, isNil } from 'ramda';
import { useReactiveVar } from '@apollo/client';
import {useDispatch} from 'react-redux';
import { shipping } from '../../settings';
import { FieldArray } from 'react-final-form-arrays';
import { pathOr } from 'ramda';
import t1 from './shipping-packet/locale';
import t2 from './shipping-container/locale';
import t3 from "./shipping-packet/locale"
import { Icon, IconSize } from "@blueprintjs/core";
import { convertGQLErrors, isEqualById,isEqualByJson } from '../../utils/form';
import translateErrors from '../../utils/i18n/errors-locale';
import { countryMapping } from './flag-site-currency-marker/index';
import {fetchJSONWithErrorAlert} from '../../utils/http';
import { ShippingProfilesList } from '../../pages/shipping-profiles/operations.graphql';
import { FormField, FieldValue, FieldError } from '../../hocs/final-form';
import { useApolloLightbox } from '../../hooks/use-apollo-lightbox';
import useMediaQuery from '../../hooks/use-media-query';
import { useQuery } from '@apollo/client';
import ApolloLightbox from '../apollo-lightbox';
import InputField from '../../basic-components/input-field';
import Button from '../../basic-components/button';
import SelectField from '../../basic-components/select-field';
import ColorSelectorField from '../color-selector-field';
import FieldSet from '../field-set';
import FieldSetDescription from '../field-set-description';
import FieldSetTitle from '../field-set-title';
import ThreeColumnsLayout from '../../basic-components/three-columns-layout';
import Errors from '../errors';
import Link from '../../basic-components/link';
import ExcludedCountriesLightbox from '../shipping-excluded-countries-lightbox';
import ShippingPoliciesTooltip from '../shipping-policies-tooltip';
import { selectedShippingProfileVar } from '../../utils/apollo-cache';
import { LightboxContextProvider } from '../../basic-components/lightbox/context';
import Lightbox from '../../basic-components/lightbox/index';
import originalShippingPolicyTestData from "./originalShippingPolicy.json"
import { validCostIsNumberNoSetstate } from './shipping-packet/shipping-packet-prices';

import Tariffs from './tariffs';
import PaidByField from './paid-by-field';
import LocationField from './location-field';
import ExcludedCountries from './excluded-countries';
import { ProfileTabs, GENERAL_TAB_NAME, DEFAULT_TABS, DEFAULT_TABS_WITHOUT_GENERAL_TAB } from './profile-tabs';
import CustomProfileWithShowHide from './custom-profile/withShowHide';
import { CSSTransition } from 'react-transition-group';
import useShippingProfilesList from "../../hooks/useShippingProfilesList"

import FlagSiteCurrencyMarker from "./flag-site-currency-marker/index"
import {openSuccessToast} from "../../actions/shipping";
import useShippingServices from "../../hooks/useShippingServices"

import {
  createProfileInput,
  validCustomProfilesHasEmptyShippingServiceCode,
  getInvalidGeneralPolicySiteLabels,
  assembleCustomProfileDataWithSite,
  getFirstLetter,
  findOriginalSite,
} from './profile-utils';
import t from './locale';
import cs from './styles.pcss';

import type { FormProfile } from './profile-utils';
import { handleMultiFreeShippingForDomestic } from './profile-utils';




import type {
  ProfileInput,
  ShippingProfileSave as ShippingProfileSaveResult,
  ShippingProfileSave_upsertProfile_profile as SavedProfile,
  ShippingProfileAdditional_regions as Regions,
} from '../../typings/product-query.flow';

const cx = classNames.bind(cs);

const TabMapping = {
  us: 0,
  uk: 3,
  de: 77,
  fr: 71,
  it: 101,
  es: 186,
  au: 15,
  ca: 2,
};

type Props = {
  shippingProfile: ?FormProfile,
  countries: Array<Regions>,
  defaultCurrency: string,
  disabledColorsMap: { [string]: Array<number> },
  shippingDestinations: { [string]: string },
  loading: boolean,
  error: boolean,
  onSave: (
    changes: ProfileInput
  ) => Promise<{ data: ShippingProfileSaveResult }>,
  onSaveCompleted?: (profile: SavedProfile) => void,
  duplicateProlife: string | null,
  showcases: any,
  cacheCount: number,
};

const getShippingTypes = () => [
  { label: t('fields.type.options.free'), value: shipping.pricing.free },
  { label: t('fields.type.options.flat'), value: shipping.pricing.flat },
  { label: t('fields.type.options.custom'), value: shipping.pricing.custom },
];
const noExcludedCountries = (countries) => !countries || countries.length === 0;

const getReturnOptions = () =>
  shipping.returnsOptions.map((days) => ({
    label: t(`fields.returnsWithin.options.${days ? 'days' : 'no'}`, {
      count: days,
    }),
    value: days,
    hidden: [3, 7].includes(days),
  }));

const DISPATCH_TIME_OPTIONS = shipping.dispatchTimeOptions.map((days) => ({
  label: String(days),
  value: days,
}));

const getCountries = (regions: Array<Regions>) =>
  regions
    .map(({ code, name }) => ({
      label: name,
      value: code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

const getCountriesMap = (regions: Array<Regions>) =>
  regions.reduce(
    (acc: any, { code, name }: Regions) => ({
      ...acc,
      [code]: name,
    }),
    {}
  );

const focusOnErrors = createFocusOnError();



function ShippingProfileLightboxForm({
  isNew,
  shippingProfile,
  countries,
  defaultCurrency,
  disabledColorsMap,
  shippingDestinations,
  whitelist2,
  loading,
  error,
  submitting,
  onSave,
  onSaveCompleted = () => { },
  duplicateProlife,
  showcases,
  cacheCount,
  worldwideCurrency
}: Props): React.Node {
  const veryLargeScreen = useMediaQuery(`(min-width: 1280px)`);
  const mediumScreen = useMediaQuery(`(min-width: 768px)`);
  const { closeLightbox } = useApolloLightbox('ShippingProfile');
  const profileId = useReactiveVar(selectedShippingProfileVar);
  const dispatch = useDispatch();
  const {shippingProfilesList}=useShippingProfilesList()
  const [lightBoxOpen, setLightBoxOpen] = React.useState(false);
  const [btnErrMsg, setbtnErrMsg] = useState("")

  const newProfile = !profileId || profileId === '-1';

  const [profile, setprofile] = useState({ ...shippingProfile })
  const countriesMap = getCountriesMap(countries);
  useEffect(() => {
    setprofile({
      ...shippingProfile,
    })
   
  }, [shippingProfile,profileId])

  const {domesticShippingServices:domesticShippingServices2}=useShippingServices()

  

  // DEFAULT_TABS_WITHOUT_GENERAL_TAB 国家名字
  const {
    // DB中所有domestic shipping service 可选列表
    domesticShippingServices = [],
    // DB中所有domestic shipping service 可选列表
    internationalShippingServices = [],
    // Mag根据General Policy计算得出的8大站点ebay shipping policy
    shippingEbayProfiles: computedEbayProfiles = [],
    originalShippingPolicy = null,
  } = profile;

  const COUNTRY_CODES = [
    "us",
    "uk",
    "de",
    "fr",
    "it",
    "es",
    "au",
    "ca",
    "worldwide"
  ]

  const countryIsCollapseConstant= {
    "us": false,
    "uk": false,
    "de": false,
    "fr": false,
    "it": false,
    "es": false,
    "au": false,
    "ca": false,
    "worldwide": false
  }

  const [countryIsCollapse, setcountryIsCollapse] = useState(
   {...countryIsCollapseConstant}
  )

  useEffect(() => {
    setcountryIsCollapse({...countryIsCollapseConstant})
  }, [profileId])
  

  const renderFooter =
    (
      duplicateProlife: string | null,
      handleSubmit?: any,
      submitError?: boolean,
      generalPolicyError?: string,
      submitting?: boolean,
      mediumScreen: boolean = true,
      errorHidden: boolean = false,
      form
    ) =>
      (closeOverlay: () => Promise<void>) =>
      (
        <>
          <ThreeColumnsLayout
            left={
              <Button
                onClick={closeOverlay}
                mode="secondary"
                size={mediumScreen ? 'medium' : 'inModal'}
              >
                {t('buttons.close')}
              </Button>
            }
            center={
              <div style={{position:'relative'}}>
                <Button
                  loading={submitting}
                  onClick={handleSubmit}
                  size={mediumScreen ? 'medium' : 'inModal'}
                >
                  {t(duplicateProlife ? 'buttons.save' : 'buttons.applyChanges')}
                </Button>
                <div style={{position:'absolute', left:'100%', top:'50%', transform:'translateY(-50%)', display:'flex', flexDirection:'column', paddingLeft:'20px', whiteSpace:'nowrap'}}>
                  {submitError?.length>0&&<div style={{ color: 'rgb(230, 32, 72)', fontSize:'12px', lineHeight:'20px' }}>{submitError}</div>}
                  {generalPolicyError?.length>0&&<div style={{ color: 'rgb(230, 32, 72)', fontSize:'12px', lineHeight:'20px' }}>{generalPolicyError}</div>}
                  {btnErrMsg?.length>0&&<div style={{ color: 'rgb(230, 32, 72)', fontSize:'12px', lineHeight:'20px' }}>{btnErrMsg}</div>}
                </div>
              </div>
            }

            className={cs.footerWrapper}
          />
          {duplicateProlife && (
            <Errors
              compact
              errors={[
                <div>
                  {`${t('duplicateError.reason')}: `}
                  <span className={cs.duplicateTitle}>{duplicateProlife}.</span>
                  <br />
                  {t('duplicateError.tip')}.
                </div>,
              ]}
              className={cx('globalErrors')}
              hidden={errorHidden}
            />
          )}
       
          {/* {!duplicateProlife && submitError && (
            <Errors
              compact
              errors={[submitError]}
              className={cx('globalErrors')}
              hidden={errorHidden}
            />
          )} */}
          {/* As we have already have one submitError above, so we don't need to show it again here.  */}
        </>
      );
  // const originalSite = findOriginalSite(profile);
  const originalSite = findOriginalSite(originalShippingPolicy);
  const notBig8Site =
    originalSite !== 'unknown' &&
    !Object.values(TabMapping).includes(originalSite);
  const profileTabNames = notBig8Site
    ? [...DEFAULT_TABS, 'other']
    : [...DEFAULT_TABS];

  // const existingShippings=handleMultiFreeShippingForDomestic(dsServices)
  const existingShippings = handleMultiFreeShippingForDomestic([{

  }])
  const existingShippingsRef = React.useRef([...existingShippings]);

  const [selectedTab, setSelectedTab] = React.useState(GENERAL_TAB_NAME);
  const isGeneralProfileTab = selectedTab === GENERAL_TAB_NAME;
  const [shippingEbayProfiles, setShippingEbayProfiles] = React.useState([]);
  const [errorHidden, setErrorHidden] = React.useState(false);
  const [btnIsAvailable, setbtnIsAvailable] = useState(true)

  React.useEffect(() => {
    setShippingEbayProfiles([]);
    setSelectedTab(GENERAL_TAB_NAME);
    setErrorHidden(true);
  }, [profileId, cacheCount]);

  if (error) {
    return null;
  }

  const selectTab = (tabName: string) => {
    setSelectedTab(tabName);
    if (tabName !== GENERAL_TAB_NAME) {
      const siteId = TabMapping[tabName];
      let existed;

      // 如果Mag已经生成了eBay profile, computedEbayProfiles是非空数组
      if (
        shippingEbayProfiles.length === 0 &&
        computedEbayProfiles.length > 0
      ) {
        existed = computedEbayProfiles?.find((item) => item.siteId == siteId);
   
        // 这里应该只会执行一次
        if (existed) {
          // 更新ShippingEbayProfiles，后面都会用ShippingEbayProfiles查询
          setShippingEbayProfiles([...computedEbayProfiles]);
          return;
        }
      }

      // 1. Mag还没有生成ebay profile， computedEbayProfiles为[]，每个tab都会call api
      // 2. 或者computedEbayProfiles有值，但没有当前tab的信息，也会call api
      existed = shippingEbayProfiles?.find((item) => item.siteId == siteId);
      if (!existed) {
        fetch(`/shipping/ebay_profile/${profileId}/${siteId}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.id) {
              setShippingEbayProfiles((current) => [...current, data]);
            }
          });
      }
    }
  };
 


  const cancelButton = (closeOverlay: () => Promise<void>) => (
    <Button
      mode="secondary"
      onClick={closeOverlay}
      size={'medium'}
    >
      {t('resync.cancel')}
    </Button>
  );

  const syncButton = (closeOverlay: () => Promise<void>) => (
    <Button
      loading={loading}
      onClick={() =>{

         setbtnIsAvailable(false)
                  if (profile.id) {
                    fetchJSONWithErrorAlert(`/shipping/ebay_profile_resync/${profileId}`,{},dispatch,false,true)
                      .then((data) => {
                        const { resync_result } = data
                        if(resync_result==1){
                          setLightBoxOpen(false)
                          closeLightbox()
                          selectedShippingProfileVar(-1)
                          dispatch(openSuccessToast())
                          if (!window.location.href.includes('stock')) {
                            shippingProfilesList.refetch()
                            }
                        }else if(resync_result==3){
                          setLightBoxOpen(false)
                          closeLightbox()
                          selectedShippingProfileVar(-1)

                          dispatch(openSuccessToast())
                          if (!window.location.href.includes('stock')) {
                            shippingProfilesList.refetch()
                            }
                            closeOverlay()
                        }
                      }).catch(err => {
                      }).finally(() => {
                        setbtnIsAvailable(true)
                       
                      });
                  }
                  
      }

      }
      size={ 'medium'}
    >
      {t('resync.confirm')}
    </Button>
  );

  const renderFooter2 = (closeOverlay) => {
   
    return (
      <ThreeColumnsLayout
        left={cancelButton(closeOverlay)}
        right={syncButton(closeOverlay)}
      />
    );
  }




  return (

    <>
      <Form
      initialValues={profile}
      initialValuesEqual={whitelist2?isEqualByJson:isEqualById} //测试一下
      subscription={{
        submitting: true,
        submitError: true,
        submitFailed: true,
        errors: true,
        values: true,
      }} // rerender form component only when submitting is changed
      mutators={{ ...arrayMutators }}
      decorators={[focusOnErrors]}
      onSubmit={  (data, form) => {
        const invalidGeneralPolicySiteLabels = getInvalidGeneralPolicySiteLabels(
          data?.tariffsNew,
          null,
          originalSite
        );

        if (whitelist2 && invalidGeneralPolicySiteLabels.length > 0) {
          return {
            [FORM_ERROR]: t('generalPolicyRequiredFieldsMissing', {
              sites: invalidGeneralPolicySiteLabels.join(', '),
            }),
          };
        }

        const customProfiles = assembleCustomProfileDataWithSite(profile.id);
        console.log('Custom eBay profiles', customProfiles);

        // make sure that there are no empty shipping service codes
        let errorMessage=validCustomProfilesHasEmptyShippingServiceCode(customProfiles,whitelist2,dispatch)
        if( errorMessage.trim()!==""){
        return {[FORM_ERROR]:errorMessage}
        }

        // make sure that there are no duplicate shipping service code within one site
        const { tariffsNew } = data
        if (tariffsNew != null && typeof tariffsNew == "object") {
          for (const key in tariffsNew) {
            if((!Object.keys(countryMapping).includes(key)))continue
            let shippingProfileArrWithinSite = tariffsNew[key]
            // shippingServices cannot be duplicated within one site
            if(key=="worldwide"){
              const levels = shippingProfileArrWithinSite.map(item => item.shipping_level).filter(item=>(item!=null&&item?.trim()!=""));
              const distinctLevels = new Set(levels);
              if (distinctLevels.size !== levels.length) {
                return {[FORM_ERROR]:t('duplicateShippingServicesWithinSite')}
              }
            }else if(key !== "currency"){
              const services = shippingProfileArrWithinSite.map(item => item.shipping_service).filter(item=>(item!=null&&item?.trim()!=""));
              const distinctServices = new Set(services);
              if (distinctServices.size !== services.length) {
                return {[FORM_ERROR]:t('duplicateShippingServicesWithinSite')}
              }
            }
          }
        }
       
       

      
     
        if(whitelist2===false){
          console.log('Submit form data', data);
          return  onSave(createProfileInput(data,false,dispatch))
          .then((mutationData) => {
            if (!mutationData) {
              throw new Error();
            }

            const savedProfile = path(
              ['data', 'upsertProfile', 'profile'],
              mutationData
            );

            const errors = path(
              ['data', 'upsertProfile', 'errors'],
              mutationData
            );

            if (errors && errors.length > 0) {
              setErrorHidden(false);
              return convertGQLErrors(errors, FORM_ERROR);
            }

            if (savedProfile) {
              onSaveCompleted(savedProfile);
            }

            closeLightbox();
            if (newProfile) {
              form.reset();
            }
            return null;
          })
          .catch(() => ({
            [FORM_ERROR]: translateErrors('generic_error'),
          }))
        }else{
          return new Promise((resolve,reject) => { 
            try {
              console.log('Submit form data', data);
            if(data!=null){
              onSave(createProfileInput(data,true,dispatch,worldwideCurrency))
              .then((mutationData) => {
                resolve()
                closeLightbox();
                if (!window.location.href.includes('stock')) {
                shippingProfilesList.refetch()
                }
              })
              .catch((errors) => {
               reject( {
                  [FORM_ERROR]: translateErrors('generic_error')
                })

              })
            }else{
              reject()
              }
            } catch (error) {
              reject()
            }
          })
        }
        }
      }
    >
      {({ handleSubmit, submitError, submitFailed, errors, values, submitting,form}) => {
        const invalidGeneralPolicySiteLabels = whitelist2 && submitFailed
          ? getInvalidGeneralPolicySiteLabels(values?.tariffsNew, errors?.tariffsNew, originalSite)
          : [];
        const generalPolicyError = invalidGeneralPolicySiteLabels.length > 0
          ? t('generalPolicyRequiredFieldsMissing', {
              sites: invalidGeneralPolicySiteLabels.join(', '),
            })
          : '';
        const visibleSubmitError = submitError === generalPolicyError ? '' : submitError;

        return (
        <ApolloLightbox
        onClose={()=>{
          console.log("🚀 ~ file: form.js:480 ~ onClose:")
          form.restart(form.getState().values)
        }}
          id="ShippingProfile"
          header={newProfile ? t('title.create') : loading?"":profile.title}
          loading={loading}
          footer={renderFooter(
            duplicateProlife,
            handleSubmit,
            visibleSubmitError,
            generalPolicyError,
            submitting,
            mediumScreen,
            errorHidden,
            form
          )}
        >
          {!newProfile && (
            <ProfileTabs
              names={profileTabNames}
              selectedTab={selectedTab}
              onClick={selectTab}
            />
          )}

          {/* General policy setting */}
          <form
            className={cx(cs.wrapper)}
            onSubmit={(e) => e.preventDefault()}
            style={{ display: isGeneralProfileTab ? 'block' : 'none' }}
          >
            {profile.id ? (
              <div className={cx('profileId')}>Policy ID: {profile.id}</div>
            ) : null}

            {/* ------从此处开始------是新UI才有的resyncShippingProfile按钮和弹窗 */}
            {whitelist2 && !newProfile && (
              profile?.original_existing == true ? <Button
              loading={!btnIsAvailable}
                mode="secondary"
                onClick={(e) => {
                  setLightBoxOpen(true)
                }}
              >
                {t('resyncShippingProfile')}
              </Button> : <Button
                mode="secondary"
                disabled
              >
                {t('cannotBeResynced')}
              </Button>
            )}



            {/* ------从此处结束------是新UI才有的resyncShippingProfile按钮和弹窗 */}

            <FieldSet delimiter="wide">
              <FieldSetDescription>
                {t('formDescription')}
                <br />
                <br />
                {t('statement')}
              </FieldSetDescription>
              <FieldSetTitle leftColumn="1.">
                <div className={cs.subtitleContainer}>
                  {t('subtitle.description')}
                  <ShippingPoliciesTooltip
                    location="Create policy popup. Policy description."
                    noArrow
                  />
                </div>
              </FieldSetTitle>
              <FormField
                name="title"
                validate={(val) => {
                  if( !val || !val.trim() )return t('fields.title.validate.empty')
                // if(val?.length > 64)return t('shippingPolicyTitleCanNotExceed64Characters')
                  return null
                }
                }
                Component={InputField}
                label={t('fields.title.label')}
                description={t('fields.title.description')}
                placeholder={t('fields.title.placeholder')}
                noGrid={!veryLargeScreen}
              />
              <FormField
                name="dispatchTime"
                validate={(val) =>
                  isNil(val) ? t('fields.dispatchTime.validate.empty') : null
                }
                Component={SelectField}
                options={DISPATCH_TIME_OPTIONS}
                label={
                  <>
                    <div>{t('fields.dispatchTime.label')},</div>
                    <div>{t('workingDays')}</div>
                  </>
                }
                description={t('fields.dispatchTime.description')}
                placeholder={t('fields.dispatchTime.placeholder')}
                grid={6}
                onChange={({ value }) => value}
                searchable={false}
                noGrid={!veryLargeScreen}
              />
              <FieldValue name="title">
                {(title) => (
                  <FormField
                    name="color"
                    Component={ColorSelectorField}
                    label={t('fields.color.label')}
                    description={t('fields.color.description')}
                    grid={8}
                    disabledColors={
                      disabledColorsMap[getFirstLetter(title)] || []
                    }
                    noGrid={!veryLargeScreen}
                  />
                )}
              </FieldValue>
            </FieldSet>

            {/* ------从此处开始------是旧组件 */}
            {!whitelist2 && (
              <>
               <FieldSet delimiter="wide" className={cx('tariffs')}>
              <FieldSetTitle leftColumn="2.">
                <div className={cs.subtitleContainer}>
                  {t('subtitle.tariffs')}
                  <ShippingPoliciesTooltip
                    location="Create policy popup. Tariffs."
                    noArrow
                  />
                </div>
              </FieldSetTitle>
              <FormField
                name="type"
                Component={SelectField}
                label={t('fields.type.label')}
                options={getShippingTypes()}
                onChange={({ value }) => value}
                noGrid={!veryLargeScreen}
                fieldClassName={cs.fieldOnSmallScreen}
              />

              <FieldValue name="type">
                {(value) => (
                  <FieldError name="tariffs" noGrid={!veryLargeScreen}>
                    {(tariffError) => (
                      <Tariffs
                        type={value}
                        defaultCurrency={defaultCurrency}
                        shippingDestinations={shippingDestinations}
                        error={tariffError}
                        veryLargeScreen={veryLargeScreen}
                      />
                    )}
                  </FieldError>
                )}
              </FieldValue>
            </FieldSet>
            <ExcludedCountries
              name="excludedCountries"
              countries={countriesMap}
              veryLargeScreen={veryLargeScreen}
            />
            </>
            
          )}
            {/* ------从此处结束------是旧组件 */}

            {/* ------从此处开始------是新组件https://wiki.corp.ebay.com/pages/viewpage.action?pageId=1752012421 */}
            {
              whitelist2 && (
                <>
                  <FieldSet delimiter="wide" className={cx('tariffs')}>
                    <FieldSetTitle leftColumn="2.">
                      <div className={cs.subtitleContainer}>
                        {t('subtitle.tariffs')}
                        <ShippingPoliciesTooltip
                          location="Create policy popup. Tariffs."
                          noArrow
                        />
                      </div>
                    </FieldSetTitle>
                    <div style={{ fontWeight: 700, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '28px' }}>
                      <div style={{ textAlign: 'center', width: '20%' }}></div>
                      <div style={{ textAlign: 'center', width: '51%' }}>{t1('shippingService')}  
                      
                        </div>
                      <div style={{ textAlign: 'center', width: '8.5%' ,fontSize:'14px'}}>{t1('buyerPays')}</div>
                      <div style={{ textAlign: 'center', width: '7%',fontSize:'14px' }}>{t1('eachAdditionalCost')}</div>
                      <div style={{ textAlign: 'center', width: '7%',fontSize:'14px'  }}>{t1('freeShipping')}</div>
                    </div>
                    <div >


{/* I intended to treat the whole tariffsNew part as ONE <FieldArray> </FieldArray> in the very beginning as below:

                    <FieldArray>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'us',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'us',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'us',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'us',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        
                        <FlagSiteCurrencyMarker attrs={{countryCode:'de',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'de',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{countryCode:'de',price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                    </FieldArray>

and use INSERT API in arrayMutators.

However, I tested the INSERT/UNSHIFT API in arrayMutators, 
it didn't work well(the data is not updated in the UI 
and overlapping with the previous data in <FlagSiteCurrencyMarker/>) even if I set key for each <FlagSiteCurrencyMarker/>.

==>I have checked whether there's any workaround to fix such strange behavior and nether of them worked.
https://github.com/final-form/final-form-arrays/issues
https://gist.github.com/Elecweb/7f3478b01126e40ce98492de32d3f995

==>I post a reply in this thread and no response.
https://github.com/final-form/final-form-arrays/pull/96

==>I also tried to rewrite INSERT by combining PUSH and UPDATE and another error came up when I delete one record afterwards.

For safety reason, I split the whole big <FieldArray> to saveral small <FieldArray>s group by countryCode as below:

                   <FieldArray attrs={{countryCode:'us'}}>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                  </FieldArray>

                   <FieldArray attrs={{countryCode:'de'}}>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                        <FlagSiteCurrencyMarker attrs={{price:"xx",additional_price:"yy",freeShipping:"true"}}></FlagSiteCurrencyMarker>
                 </FieldArray>


For future similar requirements, you can avoid such trap or dig deep into it. 
Hopefully, there's a better solution.

*/}
                  {
                    COUNTRY_CODES.map(countryCode => {
                      const disabledByOriginalPolicy =
                        !!originalShippingPolicy &&
                        originalSite !== 'unknown' &&
                        countryCode !== 'worldwide' &&
                        Number(countryMapping[countryCode]?.siteId) === Number(originalSite);
                      return (
                      <FieldError name={`tariffsNew.${countryCode}`} >
                    {(tariffsNewError) => {
                      return (
                        <FieldArray
                        name={`tariffsNew.${countryCode}`}
                        key={`tariffsNew.${countryCode}`}
                        validate={(val) => {
                          if (val && val.length) {
                            const prices = val.map((tariff) =>tariff?.price);
                            const additionalPrices = val.map((tariff) =>tariff?.additional_price);
                  
                            if (prices && prices.length) {
                              for (let i = 0; i < prices.length; i += 1) {
                                if((validCostIsNumberNoSetstate(prices[i])==false)||(validCostIsNumberNoSetstate(additionalPrices[i])==false)){
                                  return t3('price.validate.notNumber');
                                }
                                if (Number(prices[i] || 0) < Number(additionalPrices[i] || 0)) {
                                  return t('fields.price.validate.additionalHigher');
                                }
                              }
                            }
                          }
                          return null;
                        }}
                      >
                        {
                          ({ fields }) => {
                            return <div className={cs.hoverLightBlue} onClick={e => {
                              setcountryIsCollapse({ ...countryIsCollapse, [countryCode]: !countryIsCollapse[countryCode] })
                            }}>

        {tariffsNewError && <Field error={tariffsNewError}  />} 
        {/* To be honest, I don't know why I am adding this line. Not aware of its usage at all. */}

                              <div >
                                {
                                  fields.map((field, index) => {
                                    return <div key={field} style={{ position: 'relative', ...(disabledByOriginalPolicy ? { opacity: 0.5 } : {}) }} >
                                      {
                                        <>
                                          <FlagSiteCurrencyMarker
                                            countryCode={countryCode}
                                            countryIsCollapse={countryIsCollapse}
                                            field={field}
                                            index={index}
                                            profile={profile}
                                            key={field}
                                            fields={fields}
                                            isNew={isNew}
                                            disabled={disabledByOriginalPolicy}
                                            domesticShippingServices2={domesticShippingServices2}
                                            name={field}
                                            worldwideCurrency={worldwideCurrency}
                                            onDelete={() => {
                                              fields.remove(index)
                                            }}
                                          ></FlagSiteCurrencyMarker>
                                          {
                                            index == 0 ? (countryIsCollapse[countryCode] ? <Icon icon="chevron-up" size={24} color='#2255EF' style={{ position: 'absolute', right: 0, top: '17%', cursor: 'pointer' }} /> : <Icon icon="chevron-down" size={24} color='#2255EF' style={{ position: 'absolute', right: 0, top: '17%', cursor: 'pointer' }} />) : null
                                          }
  
                                        </>
                                      }
                                    </div>
                                  })
                                }
                                {countryIsCollapse[countryCode] && <div className={cs.secondLine} style={{ marginBottom: '12px', marginLeft: '240px', ...(disabledByOriginalPolicy ? { opacity: 0.5 } : {}) }} onClick={e => {
                                  setcountryIsCollapse({ ...countryIsCollapse, [countryCode]: !countryIsCollapse[countryCode] })
                                }}>
                                  <Button
                                    mode="secondary"
                                    onClick={(e) => {
                                      const newShippingEntry = countryCode == "worldwide"? { 
                                        "shipping_level": "",
                                         "price":0, 
                                         "additional_price": 0, 
                                         "free_shipping": false 
                                        }:{ 
                                        "shipping_service": "",
                                         "price":0, 
                                         "additional_price": 0, 
                                         "free_shipping": false 
                                        }
                                      fields.push({ ...newShippingEntry })
                                      e.stopPropagation()
                                    }}
                                    disabled={disabledByOriginalPolicy || (countryCode == "worldwide" ? fields?.value?.length > 3 : fields?.value?.length > 3)}
                                  >
                                    {t2('addShipping')}
                                  </Button>
                                  <span className={cs.shippingCount}>
                                    {fields && fields.value ? fields.value.length : 0}/{countryCode == "worldwide" ? 4 : 4}
                                  </span>
                                </div>}
                              </div>
  
                            </div>
                          }
                        }
                      </FieldArray>
                      )
                    }}
                  </FieldError>
                      )
                    })
                  }


                    </div>

                  </FieldSet>
                  <ExcludedCountries
                    name="excludedCountries"
                    countries={countriesMap}
                    veryLargeScreen={veryLargeScreen}
                  />
                  </>
              )
            }
            {/* ------从此处结束------是新组件https://wiki.corp.ebay.com/pages/viewpage.action?pageId=1752012421 */}

            <FieldSet delimiter="wide">
              <FieldSetTitle leftColumn="3.">
                <div className={cs.subtitleContainer}>
                  {t('subtitle.returns')}
                  <ShippingPoliciesTooltip
                    location="Create policy popup. Item location and return options."
                    noArrow
                  />
                </div>
              </FieldSetTitle>
              <FormField
                name="country"
                validate={(val) =>
                  !val || !val.trim()
                    ? t('fields.country.validate.empty')
                    : null
                }
                Component={SelectField}
                searchable
                options={getCountries(countries)}
                label={t('fields.country.label')}
                onChange={({ value }) => value}
                fieldClassName={cs.fieldOnSmallScreen}
              />
              {/* Combined field for `city` and `postalCode` inputs */}
              <LocationField fieldClassname={cs.locationField} />
              <FormField
                name="returnsWithin"
                Component={SelectField}
                options={getReturnOptions()}
                label={t('fields.returnsWithin.label')}
                description={
                  <div>
                    {t('fields.returnsWithin.description')}{' '}
                    <Link
                      href="https://www.ebay.com/pages/help/sell/top-rated.html"
                      target="_blank"
                    >
                      {t('fields.returnsWithin.link')}
                    </Link>
                  </div>
                }
                onChange={({ value }) => value}
                fieldClassName={cs.fieldOnSmallScreen}
              />
              <FieldValue name="returnsWithin">
                {(returnsWithin) =>
                  returnsWithin !== 0 && (
                    <FormField
                      name="returnsPaidByBuyer"
                      type="checkbox"
                      Component={PaidByField}
                      label={t('fields.returnsPaidByBuyer.label')}
                      fieldClassName={cs.fieldOnSmallScreen}
                    />
                  )
                }
              </FieldValue>
            </FieldSet>

            <FormField
              name="excludedCountries"
              Component={ExcludedCountriesLightbox}
            />
          </form>

          {/* FIXME：Clumsy and repetitive writing */}
          {!newProfile && (
            <>
              <CustomProfileWithShowHide
                form={form}
                key="cp-us"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'us'}
                profileId={profile.id}
                name="us"
                siteId={0}
                currency="USD"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 0}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-uk"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'uk'}
                profileId={profile.id}
                name="uk"
                siteId={3}
                currency="GBP"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 3}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-de"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'de'}
                profileId={profile.id}
                name="de"
                siteId={77}
                currency="EUR"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 77}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-au"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'au'}
                profileId={profile.id}
                name="au"
                siteId={15}
                currency="AUD"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 15}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-fr"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'fr'}
                profileId={profile.id}
                name="fr"
                siteId={71}
                currency="EUR"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 71}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-it"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'it'}
                profileId={profile.id}
                name="it"
                siteId={101}
                currency="EUR"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 101}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-es"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'es'}
                profileId={profile.id}
                name="es"
                siteId={186}
                currency="EUR"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 186}
                originalShippingPolicy={originalShippingPolicy}
              />
              <CustomProfileWithShowHide
                form={form}
                key="cp-ca"
                setbtnErrMsg={setbtnErrMsg}
                visible={!isGeneralProfileTab && selectedTab === 'ca'}
                profileId={profile.id}
                name="ca"
                siteId={2}
                currency="CAD"
                domesticShippingServices={domesticShippingServices}
                internationalShippingServices={internationalShippingServices}
                shippingEbayProfiles={shippingEbayProfiles}
                showcases={showcases}
                isOriginalSite={originalSite === 2}
                originalShippingPolicy={originalShippingPolicy}
              />
              {/* 非8大站点 */}
              {notBig8Site && originalSite !== 'unknown' && (
                <CustomProfileWithShowHide
                  form={form}
                  key="cp-other"
                  setbtnErrMsg={setbtnErrMsg}
                  visible={!isGeneralProfileTab && selectedTab === 'other'}
                  profileId={profile.id}
                  name="other"
                  siteId={originalSite}
                  domesticShippingServices={domesticShippingServices}
                  internationalShippingServices={internationalShippingServices}
                  shippingEbayProfiles={shippingEbayProfiles}
                  showcases={showcases}
                  // 如果有非8大站点，那么该站点一定是原始站点
                  isOriginalSite
                  originalShippingPolicy={originalShippingPolicy}
                />
              )}
            </>
          )}
        </ApolloLightbox>
        )
      }}
    </Form>
    {
      (profileId != -1 && profileId != null)&&
      <LightboxContextProvider>
  <Lightbox
                small
                onClose={() => setLightBoxOpen(false)}
                opened={lightBoxOpen}
                header={t('resyncShippingProfile')}
                footer={renderFooter2}
                contentClass={cx('content')}
              >{t('confirmToResync')}{' '}
              <br/>
                <span className={cx('account')}>
                 <span className={cx('accountName')}>{originalShippingPolicy?.name}</span>
                <br/>
                {/* Policy ID:  <span className={cx('accountName')}>{profileId}</span>{' ?'}
                <br/> */}
                </span>
              </Lightbox>
    </LightboxContextProvider>
    }
   </>
  
  );
}

export default ShippingProfileLightboxForm;
